// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2R9Df","paymentContainer":"PaymentPage_paymentContainer__uEEIk"};